export const CRITICAL_CSS_ATTRIBUTE = 'data-critical-css-for';

export const CRITICAL_CSS_INDEX_FILE_NAME = 'critical-css-index.json';

export const ASYNC_STYLESHEET_ATTRIBUTE = 'data-async-stylesheet';

// Set by the swap script on error, since a failed link fires no later event yet still has a non-null sheet.
export const ASYNC_STYLESHEET_FAILED_ATTRIBUTE = 'data-async-stylesheet-failed';
